import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/main.css'

function initTheme() {
  const stored = localStorage.getItem('hs2a-theme-mode')
  const mode = stored ? JSON.parse(stored) : 'system'
  const isDark = mode === 'dark' || (mode === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)
  if (isDark) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
}

initTheme()

const app = createApp(App)
app.use(router)
app.mount('#app')
